import React, { useEffect, useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Banner from "../../Layout/Banner";
import DagBoekList from "./detail/DagBoekList";
import { getUser, getUserdetails } from "../../Localstorage/localstorage";
import Swal from "sweetalert2";
import {
  AXIOS_DELETE,
  AXIOS_POST,
  AXIOS_UPDATE,
  AXIOS_UPLOAD_DOCUMENT,
} from "../../server/api/crud";
import ReInput from "../../Componenten/Layout/ReInput";
import TypeNote from "./TypeNote";
import { Radio, RadioGroup } from "@headlessui/react";
import UploadBestand from "../../Componenten/ImageUpload/UploadBestand";
import ReInputAttachtments from "../../Componenten/Layout/ReInputAttachtments";
import MonthViewEetdagboek from "../../Componenten/CalenderEetdagboek/MonthViewEetdagboek";
import RPDrawerComment from "../../Componenten/Drawers/RPDrawerComment";
import UploadBestandInput from "../../Componenten/ImageUpload/UploadBestandInput";
import Spinner from "../../Componenten/Spinner";
import moment from "moment";
import { sanitizeHtml } from "../../utils/sanitizeHtml";
import {
  CalendarIcon,
  ChatBubbleLeftIcon,
  CloudArrowDownIcon,
  DocumentIcon,
} from "@heroicons/react/24/solid";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const memoryOptions = [
  { name: "Dag", type_note: 1 },
  { name: "Ontbijt - Lunch - Dinner", type_note: 2 },
  { name: "Uren in een dag", type_note: 3 },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const EetdagboekClient = ({}) => {
  const [dagboeken, setDagboeken] = useState([]);
  const user = getUser();
  const userdetails = getUserdetails();
  const [loading, setLoading] = useState(false);
  const [command, setCommand] = useState("insert");
  const [refresh, setRefresh] = useState(false);
  const [view, setView] = useState(1);
  const [file, setFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [mobileListOpen, setMobileListOpen] = useState(false);
  const eetdagboek = {
    user_id: user?.id,
    datum: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    dag: "",
    ochtend: "",
    voormiddag: "",
    middag: "",
    namiddag: "",
    avond: "",
    smorgens: "",
    smiddags: "",
    savonds: "",
    type_note: 1,
    title: "",
  };

  const [dates, setdates] = useState({
    startdate: moment().startOf("month").format("YYYY-MM-DD"),
    enddate: moment().endOf("month").format("YYYY-MM-DD"),
  });

  const [formData, setFormData] = useState(eetdagboek);

  const refreshForm = () => {
    setFormData(eetdagboek);
    setFile(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AXIOS_POST(`eetdagboek/user`, {
          id: user?.id,
          startdate: moment(dates?.startdate).format("YYYY-MM-DD"),
          enddate: moment(dates?.enddate).format("YYYY-MM-DD"),
        });
        const eetdagboeken = response.data.data;
        setDagboeken(eetdagboeken);
        setRefresh(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // if (refresh) {
    fetchData();
    // }
  }, [refresh, user?.id, dates?.startdate, dates?.enddate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: name != 'datum' ? value :  moment(value).format("YYYY-MM-DD HH:mm:ss")}));
  };

  const validateForm = () => {
    if (!formData.title.trim()) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Gegevens niet opgeslagen. Gelieve al de velden invullen.",
        showConfirmButton: false,
        timer: 2500,
      });
      return false;
    }
    return true;
  };

  const Opslaan = async () => {
    if (!validateForm()) return;

    console.log('Form =>>',formData)
    if (command == "wijzigen") {
      try {
        await AXIOS_UPDATE(`eetdagboek`, formData.id, formData);
        setCommand(null);
        setFile(null);
        Swal.fire("Gegevens zijn gewijzigd", "", "success");
        setRefresh(true);
      } catch (error) {
        console.error("Error updating data:", error);
        Swal.fire("Er is een fout opgetreden bij het wijzigen", "", "error");
      }
    } else {
      try {
        const result = await Swal.fire({
          icon: "question",
          title: "Wilt u deze gegevens opslaan?",
          showCancelButton: true,
          confirmButtonText: "Opslaan",
          cancelButtonColor: "gray",
          confirmButtonColor: "#111827",
          cancelButtonText: "Annuleer",
        });

        if (result.isConfirmed) {
          await AXIOS_POST(`eetdagboek`, formData);
          refreshForm();

          setCommand(null);
          Swal.fire(
            "Eetdagboek is vandaag ingevuld en opgeslagen",
            "",
            "success"
          );
          setRefresh(true);
        }
      } catch (error) {
        console.error("Error saving data:", error);
        Swal.fire("Er is een fout opgetreden bij het opslaan", "", "error");
      }
    }
  };

  const EditTekst = async (item, cmd) => {
    const result = await Swal.fire({
      title: "Wenst u de gegevens te wijzigen?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Wijzigen",
      denyButtonText: "Verwijderen",
      cancelButtonColor: "gray",
      cancelButtonText: "Annuleer",
      confirmButtonColor: "#111827",
      denyButtonColor: "red",
    });

    if (result.isConfirmed) {
      setCommand(cmd);
      setShowEdit(false);
      setFormData((prev) => ({
        ...prev,
        id: item?.eetdagboek_id || null,
        user_id: item?.eetdagboek_user_id || "",
        datum: item?.eetdagboek_datum || new Date(),
        dag: item?.eetdagboek_dag || "",
        ochtend: item?.eetdagboek_ochtend || "",
        voormiddag: item?.eetdagboek_voormiddag || "",
        middag: item?.eetdagboek_middag || "",
        namiddag: item?.eetdagboek_namiddag || "",
        avond: item?.eetdagboek_avond || "",
        smorgens: item?.eetdagboek_smorgens || "",
        smiddags: item?.eetdagboek_smiddags || "",
        savonds: item?.eetdagboek_savonds || "",
        type_note: item?.eetdagboek_type_note || 1,
        title: item?.eetdagboek_title || "",
        url: item?.eetdagboek_url || "",
      }));
    } else if (result.isDenied) {
      setCommand(null);
      const deleteResult = await Swal.fire({
        title: "Ben u zeker deze gegevens te willen verwijderen?",
        showCancelButton: true,
        confirmButtonText: "Ja",
        cancelButtonText: "Neen",
        confirmButtonColor: "#111827",
      });

      if (deleteResult.isConfirmed) {
        setCommand(null);
        let id = Number(item?.eetdagboek_id);
        const res = await AXIOS_DELETE(`eetdagboek`, id);

        Swal.fire({
          title: "Gegevens zijn verwijderd",
          icon: "success",
          confirmButtonColor: "green",
        });

        setRefresh(true);
      }
    }
  };

  const ShowText = (item) => {
    setFormData((prev) => ({
      ...prev,
      id: item?.eetdagboek_id || "",
      user_id: item?.eetdagboek_user_id || "",
      datum: item?.eetdagboek_datum || new Date(),
      dag: item?.eetdagboek_dag || "",
      ochtend: item?.eetdagboek_ochtend || "",
      voormiddag: item?.eetdagboek_voormiddag || "",
      middag: item?.eetdagboek_middag || "",
      namiddag: item?.eetdagboek_namiddag || "",
      avond: item?.eetdagboek_avond || "",
      smorgens: item?.eetdagboek_smorgens || "",
      smiddags: item?.eetdagboek_smiddags || "",
      savonds: item?.eetdagboek_savonds || "",
      type_note: item?.eetdagboek_type_note || 1,
      title: item?.eetdagboek_title || "",
      admin: item?.eetdagboek_admin,
      admin_id: item?.eetdagboek_admin_id,
      score: item?.eetdagboek_score || 0,
      opmerking: item?.eetdagboek_opmerking || "",
      url: item?.eetdagboek_url || "",
    }));

    setShowEdit(true);
  };

  const openEntryFromList = (item) => {
    ShowText(item);
    setMobileListOpen(false);
  };

  const editWithClose = (item, cmd) => {
    setMobileListOpen(false);
    return EditTekst(item, cmd);
  };

  const sidebarList = (
    <div className="mt-6 py-2">
      {dagboeken?.length > 0 ? (
        <DagBoekList
          editTekst={editWithClose}
          showText={openEntryFromList}
          setView={setView}
          dagboeken={dagboeken}
        />
      ) : (
        <div className="rounded-xl border border-dashed border-wa-border bg-wa-panel2/40 px-4 py-8 text-center">
          <p className="text-sm text-wa-muted">Geen gegevens gevonden</p>
        </div>
      )}
    </div>
  );

  const renderSidebarFilters = (forDrawer) => {
    const idSfx = forDrawer ? "-drawer" : "";
    return (
      <div className="rounded-2xl border border-wa-border bg-wa-panel2/70 p-4 shadow-[0_16px_48px_-28px_rgba(0,0,0,0.55)]">
        <h3 className="text-sm font-semibold tracking-tight text-wa-text">Filter op datum</h3>
        <p className="mt-1 text-xs text-wa-muted">Toon dagboeken binnen dit bereik</p>
        <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:items-stretch">
          <input
            type="date"
            name="startdate"
            id={`startdate${idSfx}`}
            placeholder="datum"
            className="min-w-0 flex-1 rounded-lg border border-wa-border bg-wa-panel px-2.5 py-2.5 text-sm text-wa-text shadow-sm outline-none transition-colors focus:border-wa-accent/50 focus:ring-2 focus:ring-wa-accent/20"
            value={moment(dates.startdate).format("YYYY-MM-DD")}
            onChange={(e) => setdates({ ...dates, startdate: e.target.value })}
          />
          <input
            type="date"
            name="enddate"
            id={`enddate${idSfx}`}
            placeholder="datum"
            className="min-w-0 flex-1 rounded-lg border border-wa-border bg-wa-panel px-2.5 py-2.5 text-sm text-wa-text shadow-sm outline-none transition-colors focus:border-wa-accent/50 focus:ring-2 focus:ring-wa-accent/20"
            value={moment(dates.enddate).format("YYYY-MM-DD")}
            onChange={(e) => setdates({ ...dates, enddate: e.target.value })}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {view == 2 ? (
        <MonthViewEetdagboek
          user={user}
          userdetails={userdetails}
          setView={setView}
          appointments={dagboeken}
        />
      ) : (
        <div className="relative flex min-h-0 flex-1 bg-wa-app text-wa-text">
          <Transition.Root show={mobileListOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[65] xl:hidden" onClose={setMobileListOpen}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-200"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/60" aria-hidden="true" />
              </Transition.Child>
              <div className="fixed inset-0 flex">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-out duration-200"
                  enterFrom="-translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in duration-150"
                  leaveFrom="translate-x-0"
                  leaveTo="-translate-x-full"
                >
                  <Dialog.Panel className="relative flex h-full w-[min(100%,22rem)] flex-col border-r border-wa-border bg-wa-panel shadow-xl">
                    <div className="flex items-center justify-between border-b border-wa-border px-4 py-3">
                      <Dialog.Title className="text-sm font-semibold text-wa-text">
                        Mijn invullingen
                      </Dialog.Title>
                      <button
                        type="button"
                        className="rounded-lg p-2 text-wa-muted hover:bg-wa-hover hover:text-wa-text"
                        onClick={() => setMobileListOpen(false)}
                        aria-label="Sluiten"
                      >
                        <XMarkIcon className="h-5 w-5" />
                      </button>
                    </div>
                    <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4">
                      {renderSidebarFilters(true)}
                      {sidebarList}
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition.Root>

          <aside className="hidden shrink-0 overflow-y-auto border-r border-wa-border bg-wa-panel px-4 py-6 sm:px-5 xl:block xl:w-[min(100%,22rem)] 2xl:w-[26rem]">
            {renderSidebarFilters(false)}
            {sidebarList}
          </aside>
          <main className="min-h-0 min-w-0 flex-1 overflow-y-auto lg:min-h-0">
            <div className="mx-auto flex max-w-5xl flex-col px-3 pb-10 pt-3 sm:px-6 sm:pt-4 lg:px-8">
              <div className="mb-3 flex gap-2 xl:hidden">
                <button
                  type="button"
                  onClick={() => setMobileListOpen(true)}
                  className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl border border-wa-border bg-wa-panel2 px-3 py-2.5 text-sm font-semibold text-wa-text shadow-sm transition-colors hover:border-wa-accent/40 hover:bg-wa-hover"
                >
                  <Bars3Icon className="h-5 w-5 shrink-0 text-wa-accent" aria-hidden />
                  Invullingen &amp; filter
                </button>
              </div>
              <div className="flex flex-col gap-2 border-b border-wa-border pb-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end sm:gap-2">
                <button
                  type="button"
                  title="Calenderview"
                  onClick={() => setView(2)}
                  className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-wa-border bg-wa-panel2 px-3 py-2.5 text-sm font-semibold text-wa-text shadow-sm transition-colors hover:border-wa-accent/40 hover:bg-wa-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent sm:w-auto sm:py-2"
                >
                  Overzicht Calender
                  <CalendarIcon
                    className="h-5 w-5 text-wa-accent"
                    aria-hidden="true"
                  />
                </button>
                {!formData.id && formData.title && (
                  <UploadBestand
                    formData={formData}
                    userdetails={userdetails}
                    setLoading={setLoading}
                    linkbackend={"eetdagboek/upload"}
                    setformData={setFormData}
                    editkey={"url"}
                  />
                )}
                {formData?.opmerking && (
                  <button
                    type="button"
                    title="Opmerking geplaats door Specialist"
                    onClick={() => setOpen(true)}
                    className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-amber-500/35 bg-amber-500/10 px-4 py-2.5 text-sm font-semibold text-amber-100 shadow-sm transition-colors hover:bg-amber-500/20 sm:w-auto sm:py-2"
                  >
                    {" "}
                    Opmerking van Specialist
                    <ChatBubbleLeftIcon
                      className="h-5 w-5 text-amber-200/90"
                      aria-hidden="true"
                    />
                  </button>
                )}
                {formData.title && (
                  <button
                    type="button"
                    title="Nieuwe"
                    onClick={() => {
                      setFormData(eetdagboek);
                      setShowEdit(false);
                      setFile(null);
                      setCommand(null);
                    }}
                    className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-wa-border bg-white/10 px-3 py-2.5 text-sm font-semibold text-wa-text shadow-sm backdrop-blur-sm transition-colors hover:bg-wa-hover sm:w-auto sm:py-2"
                  >
                    {" "}
                    Nieuw
                    <DocumentIcon
                      className="h-5 w-5 text-wa-muted"
                      aria-hidden="true"
                    />
                  </button>
                )}
                {formData.title && (
                  <button
                    type="button"
                    title="Opslaan"
                    onClick={Opslaan}
                    className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-wa-accent px-3 py-2.5 text-sm font-semibold text-wa-onaccent shadow-sm transition-colors hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent sm:w-auto sm:py-2"
                  >
                    Opslaan
                    <CloudArrowDownIcon
                      className="h-5 w-5"
                      aria-hidden="true"
                    />
                  </button>
                )}
              </div>
            <div className="mt-2">
              <div className="rounded-2xl border border-wa-border bg-wa-panel p-5 shadow-[0_20px_60px_-36px_rgba(0,0,0,0.5)] sm:p-6">
                {showEdit == false && (
                  <label
                    htmlFor="datum"
                    className="mb-2 block text-sm font-medium text-wa-text"
                  >
                    Kies een datum
                  </label>
                )}
                <input
                  type="datetime-local"
                  name="datum"
                  id="datum"
                  disabled={showEdit}
                  placeholder="datum"
                  className="w-full max-w-full rounded-lg border border-wa-border bg-wa-panel2 px-3 py-2.5 text-sm text-wa-text shadow-sm outline-none transition-colors focus:border-wa-accent/50 focus:ring-2 focus:ring-wa-accent/20 disabled:cursor-not-allowed disabled:opacity-60 xl:max-w-md"
                  value={moment(formData.datum).format("YYYY-MM-DD HH:mm:ss")}
                  onChange={handleChange}
                />
                <div className="mt-4 col-span-full">
                  {showEdit == false && (
                    <RadioGroup
                      value={formData.type_note}
                      onChange={(e) =>
                        setFormData((prev) => ({ ...prev, type_note: e }))
                      }
                      className="my-6 grid grid-cols-1 gap-3 sm:grid-cols-3"
                    >
                      {memoryOptions.map((option) => (
                        <Radio
                          key={option.name}
                          value={option.type_note}
                          className={({ focus, checked }) =>
                            classNames(
                              "cursor-pointer rounded-xl px-4 py-4 text-center text-xs font-semibold transition-colors focus:outline-none",
                              focus ? "ring-2 ring-wa-accent/40 ring-offset-2 ring-offset-wa-panel" : "",
                              checked
                                ? "bg-wa-accent text-wa-onaccent shadow-sm ring-1 ring-wa-accent/60"
                                : "border border-wa-border bg-wa-panel2 text-wa-text hover:border-wa-accent/30 hover:bg-wa-hover",
                              "flex min-h-[3.25rem] items-center justify-center px-2 text-balance leading-snug"
                            )
                          }
                        >
                          {option.name}
                        </Radio>
                      ))}
                    </RadioGroup>
                  )}
                  <div className="col-span-full">
                    {showEdit == false ? (
                      <ReInputAttachtments
                        type="text"
                        id="title"
                        link={`eetdagboek/upload`}
                        name="title"
                        label="Titel"
                        placeholder="Vul de titel in"
                        setLoading={setLoading}
                        value={formData.title}
                        formData={formData}
                        onChange={handleChange}
                      />
                    ) : (
                      <div className="mt-2 flex flex-row flex-wrap items-center gap-3">
                        <div
                          dangerouslySetInnerHTML={{ __html: sanitizeHtml(formData?.title) }}
                          className="min-w-0 flex-1 rounded-lg border border-wa-border bg-wa-panel2/80 px-3 py-2.5 text-sm font-semibold leading-snug text-wa-text shadow-sm sm:px-4 sm:text-base"
                        />
                        {formData?.id ? (
                          <UploadBestandInput
                            linkbackend={`eetdagboek/upload`}
                            setLoading={setLoading}
                            userdetails={userdetails}
                            formData={formData}
                          />
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
                <TypeNote
                  admin={showEdit}
                  Eetdagboek={formData}
                  OnChange={handleChange}
                />
              </div>
            </div>
            </div>
          </main>
          {formData && (
            <RPDrawerComment
              item={formData}
              admin={formData}
              setOpen={setOpen}
              open={open}
              user={user}
            />
          )}
          {loading && (
            <div className="absolute inset-0 z-40 flex items-center justify-center bg-wa-app/80 backdrop-blur-sm">
              <Spinner />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default EetdagboekClient;
